import React from 'react'
import { PropTypes } from 'prop-types'
import moment from 'moment'
import { Link } from '@jsluna/react'
import api from '../../utils/api'

// Send Auth headers for Get file download
class DownloadLink extends React.Component {
  constructor(props) {
    super(props)
    this.handleDownloadClick = this.handleDownloadClick.bind(this)
    this.state = {
      isDownloading: false,
      children: this.props.children
    }
  }

  handleDownloadClick() {
    this.setState({
      isDownloading: true,
      children: 'Downloading...'
    })
    api.fetchFile(this.props.url)
      .then(response => response.blob())
      .then((blob) => {
        // create hidden link - clicking on link initiates download of the file in the browser
        const element = document.createElement('a')
        document.body.appendChild(element)
        element.setAttribute('href', window.URL.createObjectURL(blob))
        const fileDate = moment().format('DD-MM-YYYY [at] HH-mm')
        element.setAttribute('download', `${this.props.fileName} ${fileDate}.${this.props.fileExt}`)
        element.style.display = ''
        element.click()
        document.body.removeChild(element)
      })
      .then(() => {
        this.setState({
          isDownloading: false,
          children: this.props.children
        })
      })
  }

  render() {
    return (
      <Link
        cta
        className={this.props.className}
        href='javascript:void(0)' // eslint-disable-line
        onClick={this.handleDownloadClick}
        disabled={this.state.isDownloading}
      >
        {this.state.children}
      </Link>)
  }
}

DownloadLink.propTypes = {
  children: PropTypes.node.isRequired,
  url: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  fileExt: PropTypes.string.isRequired,
  className: PropTypes.string
}

DownloadLink.defaultProps = {
  className: null
}

export default DownloadLink



// WEBPACK FOOTER //
// ./src/components/DownloadLink/index.jsx